import { EventCategory } from '@orbit/api-types'
import { Idea, CategoryColumn } from './types'

const BOOKMARK_CATEGORIES: EventCategory[] = [
	'FoodAndDrink',
	'SeeAndDo',
	'Nature',
	'Shopping',
	'Accommodation',
	'Transportation',
	'Event',
	'Other',
]

const BOOKMARK_CATEGORY_LABELS: Record<EventCategory, string> = {
	FoodAndDrink: 'Food & Drink',
	SeeAndDo: 'See & Do',
	Nature: 'Nature',
	Shopping: 'Shopping',
	Accommodation: 'Accommodation',
	Transportation: 'Transportation',
	Event: 'Events',
	Other: 'Other',
}

export const organizeByCategorycolumns = (ideas: Idea[]): CategoryColumn[] => {
	return BOOKMARK_CATEGORIES.map(category => ({
		category,
		displayName: BOOKMARK_CATEGORY_LABELS[category],
		ideas: ideas.filter(b => b.category === category),
	}))
}
